import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../assets/css/AboutSection.css';
import aboutImage from '../assets/images/about/about.png';

// Import static logo images
import logo1 from '../assets/images/mat-logo/1.png';
import logo2 from '../assets/images/mat-logo/3.png';
import logo3 from '../assets/images/mat-logo/5.png';


const AboutSection = ({ hideKnowMore = false }) => {
  const [screenWidth, setScreenWidth] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const staticLogos = [
    { id: 1, image: logo1, name: 'Partner Logo 1' },
    { id: 2, image: logo2, name: 'Partner Logo 2' },
    { id: 3, image: logo3, name: 'Partner Logo 3' }
  ];

  // Handle responsive behavior
  const handleResize = useCallback(() => {
    const width = window.innerWidth;
    setScreenWidth(width);
    setIsMobile(width <= 767);
    setIsTablet(width >= 768 && width <= 991);
  }, []);

  useEffect(() => {
    const handleOrientationChange = () => {
      setTimeout(handleResize, 100);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleOrientationChange);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, [handleResize]);

  // Responsive slider settings - now only for mobile
  const getSliderSettings = () => {
    const baseSettings = {
      dots: false,
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,
      pauseOnHover: true,
      swipeToSlide: true,
      touchMove: true,
      accessibility: true,
      focusOnSelect: false
    };

    // Only mobile uses slider now
    if (screenWidth >= 480) {
      return {
        ...baseSettings,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplaySpeed: 3000
      };
    } else {
      return {
        ...baseSettings,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 2500,
        centerMode: true,
        centerPadding: '20%'
      };
    }
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleImageError = (e) => {
    console.warn('About image failed to load');
    e.target.style.opacity = '0.5';
  };

  // Handle touch events for mobile
  const handleTouchStart = (e) => {
    if (!isMobile) return;
    e.currentTarget.classList.add('touching');
  };

  const handleTouchEnd = (e) => {
    if (!isMobile) return;
    setTimeout(() => {
      e.currentTarget.classList.remove('touching');
    }, 150);
  };

  return (
    <div className={`about-section ${isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop'}`}>
      <div className="about-container">
        <div className="about-content">
          <h2 className="about-title">
            {isMobile ? 'About Us' : 'About US'}
          </h2>
          
          <div className="about-text-container">
           
            
               <p className="about-text">
               Design Craft is a young and dynamic office furniture manufacturer based in Al Quoz Industrial Area 1, Dubai. Established in 2022, we have quickly made our mark by bringing fresh, functional, and trend-forward designs to modern workspaces across the UAE.
               </p>
               <p className="about-text">
               Operating from our 8,000 sq. ft. production facility, we specialize in custom-made office furniture that combines style, comfort, and smart space utilization. Whether you're furnishing a start-up office, corporate headquarters, or a co-working space, our in-house team ensures every piece is tailored to your vision and business needs.
              </p>

              
            
            
           
          </div>
          
          {/* Conditionally render Know More button */}
          {!hideKnowMore && (
            <button className="know-more-link">
              <Link to="/about">
                {isMobile ? 'Know More' : 'Know More'}
              </Link>
            </button>
          )}
          
          {/* Know More Button - Hidden for About Page */}
          {/* <div className="know-more-btn">
            <Link 
              to="/about"
              onTouchStart={handleTouchStart}
              onTouchEnd={handleTouchEnd}
              className="know-more-link"
            >
              {isMobile ? 'Know More' : 'Know More'}
              
            </Link>
          </div> */}
        </div>

        <div className="about-image">
          <div className="image-wrapper">
            <img 
              src={aboutImage} 
              alt="Design Craft Office Space"
              onLoad={handleImageLoad}
              onError={handleImageError}
              className={imageLoaded ? 'loaded' : 'loading'}
              loading="lazy"
            />
            {!imageLoaded && (
              <div className="image-placeholder">
                <div className="loading-container">
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      
      {/* Logo slider section moved outside of about-container for better responsive control */}
      <div className="logo-slider-section">
        <div className="logo-slider-container">
          {isMobile ? (
            // Mobile: Use slider
            <Slider {...getSliderSettings()}>
              {staticLogos.map((logo, index) => (
                <div key={logo.id} className="logo-slide">
                  <div 
                    className="logo-wrapper"
                    style={{
                      animationDelay: `${index * 0.2}s`
                    }}
                  >
                    <img
                      src={logo.image}
                      alt={logo.name}
                      className="logo-image"
                      loading={index < 2 ? 'eager' : 'lazy'}
                    />
                  </div>
                </div>
              ))}
            </Slider>
          ) : (
            // Desktop & Tablet: Display 3 images directly in a grid
            <div className="logo-grid">
              {staticLogos.map((logo, index) => (
                <div 
                  key={logo.id} 
                  className="logo-item"
                  style={{
                    animationDelay: `${index * 0.2}s`
                  }}
                >
                  <div className="logo-wrapper">
                    <img
                      src={logo.image}
                      alt={logo.name}
                      className="logo-image"
                      loading={index < 2 ? 'eager' : 'lazy'}
                    />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AboutSection; 